var angular = require('angular');
import $ from 'jquery';

export default angular.module('asWorkflow', []).component('asWorkflow', {
    template: require('./asWorkflow.component.html'),
    styleUrls: require('./asWorkflow.component.css'),
    controller: ['$scope', '$compile', '$element', asWorkflowComponent],
    bindings: {
        items: '<',
        resolve: '<',
        ngModel: '=',
        callback: '&',
        ngClass: '<',
        options: '<'
    }
});

function asWorkflowComponent($scope, $compile, $element) {
    var vm = this;

    vm.$onInit = function() {
        var options = {
            workflow: true
        };

        vm.options = angular.extend({}, options, vm.options);
    };

    vm.$onChanges = function(chgObj) {
        if (chgObj.items.currentValue !== undefined) {
            var divs = $element.find('div');
            var container;
            for (var i = 0; i < divs.length; i++) {
                var div = angular.element(divs[i]);
                if (div.hasClass('as-workflow-container')) {
                    container = div;
                }
            }
            container.empty();
            for (var j = 0; j < vm.items.length; j++) {
                var content;
                var item = vm.items[j];
                if (item.component) {
                    content = document.createElement(
                        snake_case(item.component)
                    );
                    content = angular.element(content);
                    var itemVar = 'item' + [j];
                    var attrs = {
                        'ng-init': itemVar + ' = $ctrl.items[' + j + ']',
                        'ng-show':
                            '$ctrl.ngModel.value == ' + itemVar + '.value',
                        resolve: '$ctrl.resolve',
                        callback: itemVar + '.callback(value)'
                    };
                    if (item.resolve !== undefined) {
                        if (item.bindings !== undefined) {
                            $.each(item.bindings, function(index, value) {
                                attrs[snake_case(index)] =
                                    itemVar + '.resolve.' + value;
                            });
                        } else {
                            attrsGenerator(
                                attrs,
                                item.resolve,
                                '',
                                itemVar + '.resolve'
                            );
                        }
                    }
                    content.attr(attrs);
                    var element = $compile(content)($scope);
                    container.append(element);
                }
            }
        }
    };
    vm.getClass = function(index) {
        var activeIndex = -1;
        if (vm.ngModel) {
            for (var i = 0; i < vm.items.length; i++) {
                var item = vm.items[i];
                if (item.value === vm.ngModel.value) {
                    activeIndex = i;
                    break;
                }
            }
        }

        if (index == activeIndex) {
            return 'active';
        } else if (index < activeIndex) {
            return 'previous';
        } else {
            return 'next';
        }
    };

    vm.navClick = function(item) {
        if (!item.disabled) {
            if (vm.options.workflow) {
                var modelIndex = vm.items.indexOf(vm.ngModel);
                var itemIndex = vm.items.indexOf(item);
                if (modelIndex > itemIndex) {
                    vm.ngModel = item;
                }
            } else {
                vm.ngModel = item;
            }
        }
    };

    var SNAKE_CASE_REGEXP = /[A-Z]/g;

    function snake_case(name) {
        var separator = '-';
        return name.replace(SNAKE_CASE_REGEXP, function(letter, pos) {
            return (pos ? separator : '') + letter.toLowerCase();
        });
    }

    // one way binding only support for first level
    function attrsGenerator(attrs, items, key, value) {
        for (var index in items) {
            var keyValue = key + (key != '' ? '-' : '') + snake_case(index);
            if (typeof items[index] === 'object') {
                attrsGenerator(
                    attrs,
                    items[index],
                    keyValue,
                    value + '.' + index
                );
            } else {
                attrs[keyValue] = value + '.' + index;
            }
        }
    }
}



// WEBPACK FOOTER //
// ./modules/shared/asWorkflow/asWorkflow.component.js